export const setCustomer = id => {
  return sessionStorage.setItem("customer_id", id);
};

export const getCustomer = () => {
  return sessionStorage.getItem("customer_id");
};
